export const generateDepotsOptions = (): uui.domain.ui.list.ListOptions => {
  return {
    search: {
      query: '',
      fields: ['name'],
      operator: 'and',
      exactMatch: false,
    },
    filter: [],
    sort: [
      {
        field: 'name',
        direction: 'asc',
      },
    ],
    group: [],
  }
}
